import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StateModule } from '@spartacus/core';
import { effects } from './effects/index';

import { BROWSER_STORAGE } from './shared.state';
import { sharedReducer } from './reducers/index';
import { SharedEffectsService } from './effects/shared-effect.service';

@NgModule({
    imports: [
        CommonModule,
        StateModule,
        StoreModule.forFeature(BROWSER_STORAGE, sharedReducer),
        EffectsModule.forFeature(effects),
    ],
    providers: [SharedEffectsService],
})
export class SharedStoreModule { }

